import classNames from 'classnames'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './SignOffAlert.module.scss'

export const SignOffAlert = () => {
  return (
    <div className={styles.alert}>
      <i className={classNames(styles.alert__icon, 'kbase kbase-warning-alt')} />
      <div>
        <Translation text={'jbp-warning-clear-commitment'} />
      </div>
    </div>
  )
}

interface IProps {
  threshold: number
}
export const BPUnfilledAlert = ({ threshold }: IProps) => {
  return (
    <div className={styles.alert}>
      <i className={classNames(styles.alert__icon, 'kbase kbase-warning-alt')} />
      <div>
        <Translation text={'jbp-warning-bpcompleteness-lt-treshold'} span actionsInside />
        <span>{` (${threshold})`}</span>
      </div>
    </div>
  )
}

interface IAlertProps {
  text: string
  className?: string
}

export const AlertBlock = (props: IAlertProps) => {
  return (
    <div className={classNames(styles.alert, props.className || '')}>
      <i className={classNames(styles.alert__icon, 'kbase kbase-warning-alt')} />
      <div>
        <Translation text={props.text} />
      </div>
    </div>
  )
}
